if (!customElements.get("product-form")) {
	customElements.define(
		"product-form",
		class ProductForm extends HTMLElement {
			constructor() {
				super();

				this.form = this.querySelector("form");
				this.variantInput = this.form?.querySelector("[name=id]");
				if (!this.form || !this.variantInput) return;
				this.variantInput.disabled = false;
				this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
				this.cart = document.querySelector("cart-drawer");
				this.submitButtons = this.querySelectorAll('[type="submit"]');
				this.submitButton = this.submitButtons[0];
				this.isSubmitting = false;
				if (
					this.cart &&
					typeof this.cart.getSectionsToRender === "function"
				)
					this.submitButtons.forEach((button) => {
						if (button.dataset.directCheckout !== "true")
							button.setAttribute("aria-haspopup", "dialog");
					});

				this.hideErrors = this.dataset.hideErrors === "true";
			}

			async onSubmitHandler(evt) {
				evt.preventDefault();
				this.submitButton = evt.submitter || this.submitButtons[0];
				if (
					!this.submitButton ||
					this.submitButton.disabled ||
					this.isSubmitting
				)
					return;

				this.handleErrorMessage();
				const directCheckout =
					this.submitButton.dataset.directCheckout === "true" ||
					(this.dataset.directCheckout === "true" &&
						this.submitButton.dataset.cartAction !== "true");

				this.isSubmitting = true;
				this.submitButton.setAttribute("aria-disabled", true);
				this.submitButton.classList.add("loading");
				this.submitButton
					.querySelector(".loading-overlay__spinner")
					?.classList.remove("hidden");

				const config = fetchConfig("javascript");
				config.headers["X-Requested-With"] = "XMLHttpRequest";
				delete config.headers["Content-Type"];

				const formData = new FormData(this.form);
				if (
					!directCheckout &&
					this.cart &&
					typeof this.cart.getSectionsToRender === "function"
				) {
					formData.append(
						"sections",
						this.cart.getSectionsToRender().map((section) => section.id)
					);
					formData.append("sections_url", window.location.pathname);
					this.cart.setActiveElement(document.activeElement);
				}
				config.body = formData;

				try {
					const fetchResponse = await fetch(`${routes.cart_add_url}`, config);
					const response = await fetchResponse.json();

					if (!fetchResponse.ok || response.status) {
						const message =
							response.description || response.message || "Unable to add this item.";
						publish(PUB_SUB_EVENTS.cartError, {
							source: "product-form",
							productVariantId: formData.get("id"),
							errors: message,
							message: response.message,
						});
						this.handleErrorMessage(message);
						return;
					}

					if (directCheckout) {
						window.location.assign(window.routes?.checkout_url || "/checkout");
						return;
					}

					if (!this.cart) {
						window.location.assign(window.routes?.cart_url || "/cart");
						return;
					}

					publish(PUB_SUB_EVENTS.cartUpdate, {
						source: "product-form",
						productVariantId: formData.get("id"),
					});

					const quickAddModal = this.closest("quick-add-modal");
					if (quickAddModal) {
						document.body.addEventListener(
							"modalClosed",
							() => setTimeout(() => this.cart.renderContents(response)),
							{ once: true }
						);
						quickAddModal.hide(true);
					} else {
						this.cart.renderContents(response);
					}
				} catch (error) {
					console.error(error);
					this.handleErrorMessage("Unable to add this item. Please try again.");
				} finally {
					this.isSubmitting = false;
					this.submitButton.classList.remove("loading");
					this.submitButton.removeAttribute("aria-disabled");
					this.submitButton
						.querySelector(".loading-overlay__spinner")
						?.classList.add("hidden");
					if (this.cart?.classList.contains("is-empty"))
						this.cart.classList.remove("is-empty");
				}
			}

			handleErrorMessage(errorMessage = false) {
				if (this.hideErrors) return;

				this.errorMessageWrapper =
					this.errorMessageWrapper ||
					this.querySelector(".product-form__error-message-wrapper");
				if (!this.errorMessageWrapper) return;
				this.errorMessage =
					this.errorMessage ||
					this.errorMessageWrapper.querySelector(
						".product-form__error-message"
					);

				this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

				if (errorMessage) {
					this.errorMessage.textContent = errorMessage;
				}
			}
		}
	);
}
